import React, { useEffect, useState } from "react";
import { HandHeart } from "lucide-react";
import { money } from "@/lib/financeApi";
import { reApi, errMsg } from "@/lib/residentApi";

/** Subsidized Service Delivery for one resident: $75 of case management value per verified pillar. Not cash. */
export default function ImpactTab({ resident }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { reApi.get(`/residents/${resident.id}/service-value`).then(setD).catch((e) => setErr(errMsg(e))); }, [resident.id]);
  if (err) return <p data-testid="impact-error" className="text-sm text-red-300">{err}</p>;
  if (!d) return <p className="text-sm text-nex-muted">Loading…</p>;
  const Box = ({ label, value, tone, testid, sub }) => (
    <div data-testid={testid} className="p-4 border border-white/10 rounded-sm bg-white/[0.02]">
      <div className="nds-label-dim text-[9px]">{label}</div><div className={`font-mono text-xl ${tone}`}>{value}</div>{sub && <div className="text-[11px] text-nex-muted">{sub}</div>}
    </div>);
  return (
    <div data-testid="impact-tab" className="space-y-5">
      <div className="flex items-start gap-2 text-sm text-nex-muted"><HandHeart className="h-4 w-4 text-emerald-300 mt-0.5 shrink-0" />
        Each verified pillar is {money(d.rates.value)} of case management value delivered: {money(d.rates.program)} program investment and {money(d.rates.resident)} the resident earned. Tracking only — no cash moves and no balance changes.</div>
      <div className="grid gap-3 grid-cols-2 lg:grid-cols-4">
        <Box testid="impact-total" label="Total service value delivered" value={money(d.total)} tone="text-emerald-300" sub={`${d.pillars} verified pillar${d.pillars === 1 ? "" : "s"}`} />
        <Box testid="impact-program" label="Program direct investment" value={money(d.program)} tone="text-sky-200" sub="Cost to serve, absorbed by TEA" />
        <Box testid="impact-resident" label="Resident matched responsibility" value={money(d.resident)} tone="text-amber-200" sub="Earned value toward their growth" />
        <Box testid="impact-week-max" label="Most a week can deliver" value={money(d.rates.value * 4)} tone="text-nex-silver" sub="4 pillars × $75" />
      </div>
      <div>
        <div className="nds-label-dim text-[9px] mb-2">By week</div>
        {d.weeks.length ? d.weeks.map((w) => (
          <div key={w.week} data-testid={`impact-week-${w.week}`} className="flex items-center gap-3 text-sm border-b border-white/5 py-1.5">
            <span className="font-mono text-nex-muted w-28">{w.week}</span><span className="flex-1 text-nex-silver">{w.pillars} pillar{w.pillars === 1 ? "" : "s"}</span>
            <span className="font-mono text-emerald-300">{money(w.total)}</span><span className="font-mono text-[11px] text-nex-muted">{money(w.program)} / {money(w.resident)}</span>
          </div>)) : <p data-testid="impact-empty" className="text-sm text-nex-muted">No verified pillars yet.</p>}
      </div>
    </div>
  );
}
